// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqRequestQuotePageContainerStyles } from "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuotePageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import dataTableStyles from "@sc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

rfqRequestQuotePageContainerStyles.container = {
    css: css`
        /* stylelint-disable value-no-vendor-prefix */
        display: -ms-grid;
        display: grid;
        padding: 1.5rem 0 0 1.5rem;
        margin: -1.5rem;
        overflow: hidden;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        grid-template-columns: minmax(0, 1fr);
                        -ms-grid-columns: minmax(0, 1fr);
                    `,
                    null,
                    css`
                        grid-template-columns: 1fr 234px;
                        -ms-grid-columns: minmax(0, 1fr) minmax(0, 1fr);
                        grid-template-rows: repeat(5, auto);
                        -ms-grid-rows: auto auto auto auto auto;
                    `,
                    css`
                        grid-template-columns: minmax(0, 3fr) minmax(0, 1fr);
                        -ms-grid-columns: minmax(0, 3fr) minmax(0, 1fr);
                    `,
                ],
                "min",
            )}
    `,
};

rfqRequestQuotePageContainerStyles.specificationsContainer = {
    css: css`
        padding-top: 35px;
        ${xScreen("lte", "sm")} {
            padding-top: 0;
            max-width: 450px;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        border: 0 solid transparent;
                        border-width: 0 1.5rem 20px 0;
                    `,
                    null,
                    css`
                        grid-column-start: 2;
                        -ms-grid-column: 2;
                        grid-row-start: 1;
                        -ms-grid-row: 1;
                    `,
                ],
                "min",
            )}
    `,
};

rfqRequestQuotePageContainerStyles.emptyQuoteText = {
    ...dataTableStyles.noResultsText,
};
